module.exports = __webpack_public_path__ + "static/media/9.20006cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/9.png
// module id = 486
// module chunks = 0